import { crypt } from '../../Helper/helper';

const { createSlice } = require('@reduxjs/toolkit');

const queryMultipleBalanceApiCall = async (params) => {
  let response = await fetch('/bizcareui/api/queryMultipleBalance', {
    method: 'POST',
    headers: {
      Accept: 'application/json',
    },
    body: params,
  }).then((response) => response.json());
  return response;
};

export function getFetchAccountAndBillingData(
  pageNumber = 1,
  itemPerPage = 5,
  groupName,
  serviceTypes,
  CustID,
  name,
  router,
  subscriberStatus = '',
  bulkChange = '',
  access = '',
  paymentMethod = ''
) {
  const encrypted_textBRN = crypt(
    process.env.NEXT_PUBLIC_ENCRYPTION_KEY,
    CustID
  );
  return async function fetchAccAndbillingThunk(dispatch, getState) {
    try {
      const param = JSON.stringify({
        businessInteractionId: CustID, // '202304140101',
        groupName: groupName,
        source: 'BizCare',
        serviceType: `${serviceTypes}`,
        pageStart: pageNumber,
        pageEnd: 0,
        pageCount: itemPerPage,
        subscriberStatus: subscriberStatus,
        paymentMethod: paymentMethod ? paymentMethod : undefined,
      });
      dispatch(getselectedData({ data: {}, loading: true }));
      let response = await fetch(
        '/bizcareui/api/fetchOrgCustomerAccountDetailsByBRN',
        {
          method: 'POST',
          headers: {
            Accept: 'application/json',
          },
          body: param,
        }
      );
      const headers = {};
      for(let [key, value] of response.headers.entries()){
        headers[key] = value;
      }
      let json = await response.json();
	  console.log("accountandBillingSlice respone json", json);
      if (!json.code) {
        // dispatch(getselectedData({ data: json, loading: false, error: '' }));
        dispatch(
          getpageNumber(response.headers.get('x-row-offset'))
        );
        dispatch(
          getItemPerPage(response.headers.get('x-row-count'))
        );
        dispatch(
          gettotalSize(response.headers.get('x-total-count'))
        );
        let billingAccountNum = '';
        let params = '';
        billingAccountNum = json[0].account.map((item) => {
          return {
            AccountNo: item?.externalReference?.find(ref => ref.externalReferenceType === "cbsAccountId")?.value,
            smeGroupId: item?.characteristic?.find((char) => char.name === 'smeGroupId')?.value,
            serialNumber: item?.serviceIdentifier,
          };
        });
		console.log("accountandBillingSlice billingAccountNum", billingAccountNum);
        const list = billingAccountNum.map((item) => {
          return {
            billingAccountNumber: item?.AccountNo,
            endTime: null,
            groupId: bulkChange === 'InterShare' ? item?.smeGroupId : '',
            operateType: bulkChange === 'InterShare' ? 'DataDetails' : '',
            serialNumber: item?.serialNumber,
            startTime: '',
          };
        });
		console.log("accountandBillingSlice list", list);
        params = JSON.stringify({
          listOfCmuRequestBillingProfileIo: {
            comInvoiceProfile: list,
          },
        });
        const result = await queryMultipleBalanceApiCall(params).then(result);
        if (result) {
          dispatch(
            getQueryMultipleResponse({
              data: result,
              loading: false,
              error: '',
            })
          );

          dispatch(getselectedData({ data: json, loading: false, error: '' }));
          if (
            !json.code &&
            result
          ) {
            if (bulkChange) {
              if (
                bulkChange === 'BulkChangeAddress' ||
                bulkChange === 'BulkChangeBillMedia' ||
                bulkChange === 'BulkPayBill' ||
                bulkChange === 'ChangeBillCycle' ||
                bulkChange === 'ChangeName' ||
                bulkChange === 'InterShare'
              ) {
                router.push({
                  pathname: `/${bulkChange}`,
                  query: { name: name, value: subscriberStatus },
                });
              } else if (
                (bulkChange === 'AutoBillingRegistration' &&
                  access === 'dis') ||
                (bulkChange === 'AutoBillingRegistration' && access === 'en')
              ) {
                router.push({
                  pathname: `/${bulkChange}`,
                  query: {
                    name: name,
                    access: access,
                    value: subscriberStatus,
                  },
                });
              }
            }
            else {
              if (name === 'All Services') {
                router.push('/accountAndBilling/AllServices');
              } else if (name === 'All Share') {
                router.push('/accountAndBilling/CelcomAllShare');
              } else if (name === 'Mobile') {
                router.push('/accountAndBilling/MobilePlans');
              } else if (name === 'Data') {
                router.push('/accountAndBilling/DataPlans');
              } else if (name === 'Fibre') {
                router.push('/accountAndBilling/Fibre');
              } else if (name === 'Wireless') {
                router.push('/accountAndBilling/Wireless');
              } else if (name === 'Solution Standalone') {
                router.push('/accountAndBilling/SolutionStandalone');
              } else if (name === 'Solution Addons') {
                router.push('/accountAndBilling/SolutionAddons');
              }
            }
          }
        } else {
          dispatch(
            getQueryMultipleResponse({
              data: [],
              loading: false,
              error: `Technical failure : Couldn't able to retrieve query multiple response`,
              modalIsOpenError: true,
            })
          );
        }
      }
      // );
      // if (queryMultipleBalanceData?.listOfCmuBalanceSummaryResponseIo) {
      //   // list.push(
      //   //   queryMultipleBalanceData?.listOfCmuBalanceSummaryResponseIo
      //   //     ?.cmuBalanceSummaryVbc
      //   //   )
      //   // console.log(
      //   //   'list',
      //   //   list,
      //   //   list.push(
      //   //   queryMultipleBalanceData?.listOfCmuBalanceSummaryResponseIo
      //   //     ?.cmuBalanceSummaryVbc
      //   //   )
      //   // );
      // }
      // dispatch(
      //   getQueryMultipleResponse(list)
      // );

      // }
      else if (json?.code) {
        dispatch(
          getselectedData({
            data: [],
            loading: false,
            error: `Technical failure : Couldn't able to retrieve customer detail`,
            modalIsOpenError: true,
          })
        );
      }
    } catch (error) {
      dispatch(
        getselectedData({
          data: [],
          loading: false,
          error: `Technical failure : Couldn't able to retrieve customer detail`,
          modalIsOpenError: true,
        })
      );
    }
  };
}
const initialState = {
  custBillRetrieveRespForPlans: {
    data: {},
    loading: false,
    error: '',
    modalIsOpenError: false,
  },
  queryMultipleResDetails: {
    data: {},
    loading: false,
    error: '',
    modalIsOpenError: false,
  },
  itemPerPage: 5,
  loadingState: false,
  pageNumber: 1,
  totalSize: 0,
  selectedData: {},
  ReplicatedData: [],
  checkData: [],
};
const accountandBliingSlice = createSlice({
  name: 'accountAndBilling',
  initialState,
  reducers: {
    getselectedData: (state, action) => {
      state.custBillRetrieveRespForPlans = action.payload;
    },
    getQueryMultipleResponse: (state, action) => {
      state.queryMultipleResDetails = action.payload;
    },
    getAccountAndBillingData: (state, action) => {
      state.selectedData = action.payload;
    },
    setLoadingState: (state, action) => {
      state.loadingState = action.payload;
    },
    getItemPerPage: (state, action) => {
      state.itemPerPage = action.payload;
    },
    getpageNumber: (state, action) => {
      state.pageNumber = action.payload;
    },
    gettotalSize: (state, action) => {
      state.totalSize = action.payload;
    },
    getReplicatedData: (state, action) => {
      // console.log('action', action.payload);
      if (action.payload === undefined && state.ReplicatedData?.length > 0) {
        state.ReplicatedData.length = 0;
      } else if (
        state.ReplicatedData?.length > 0 &&
        action.payload.length > 0
      ) {
        state.ReplicatedData = [...state.ReplicatedData, ...action.payload];
      } else if (state.ReplicatedData?.length === 0) {
        state.ReplicatedData = action.payload;
      } else {
        // state.ReplicatedData.length = 0;
        state.ReplicatedData = [];
      }

      //   }
    },
    getCheckedData: (state, action) => {
      state.checkData = action.payload;
    },
    // resetAccountandbilling(state) {
    //   Object.assign(state, initialState);
    // },
    resetAccountandbilling: () => initialState,
  },
});
export const {
  getselectedData,
  getItemPerPage,
  getpageNumber,
  gettotalSize,
  getQueryMultipleResponse,
  resetAccountandbilling,
  getAccountAndBillingData,
  getReplicatedData,
  getCheckedData,
  setLoadingState,
} = accountandBliingSlice.actions;
export default accountandBliingSlice.reducer;
